import { j as n, B as b } from "./Spinner-yxPaS-Vf.js";
import p, { useRef as B, useState as F } from "react";
import { styled as g, css as u } from "styled-components";
import { c as a, a as A, B as E } from "./style-ImpGK6sv.js";
import { M as I } from "./icon-minus-wH6_GWF0.js";
import { P as M } from "./icon-plus-zj7j8_QD.js";
const N = g.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`, f = u`
  appearance: none;
  border: 2px solid ${a.black};
  border-radius: 50%;
  box-shadow: none;
  background: ${a.white};
  cursor: pointer;
  width: 24px;
  height: 24px;
`, r = u`
  box-shadow:
    0 0 0 2px ${a.white},
    0 0 0 4px ${a.greyAlpha10};
`, P = g.input.attrs({ type: "range" })`
  appearance: none;
  margin: 0 26px;
  outline: none;
  border: 1px solid ${a.greyAlpha10};
  padding: 0;
  width: 100%;
  min-width: 200px;
  height: 0;

  /* Vendor prefixes cannot be nested since browsers do not support this behavior */
  &::-webkit-slider-thumb {
    ${f}
  }

  &::-moz-range-thumb {
    ${f}
  }

  &:hover::-webkit-slider-thumb {
    ${r}
  }

  &:hover::-moz-range-thumb {
    ${r}
  }

  &:active::-webkit-slider-thumb {
    ${r}
  }

  &:active::-moz-range-thumb {
    ${r}
  }

  &:focus::-webkit-slider-thumb {
    ${r}
  }

  &:focus::-moz-range-thumb {
    ${r}
  }

  ${A(
  E.xl,
  u`
      min-width: 280px;
    `
)}
`, T = p.forwardRef(
  ({
    min: o = 0,
    max: s = 100,
    // max number should be a multiple of step number
    step: l = 10,
    id: x,
    rangeSliderAriaLabel: w,
    incrementAriaLabel: $,
    decrementAriaLabel: k,
    onChange: h,
    value: i,
    ...v
  }, y) => {
    const j = B(null), [t, d] = F(i ?? o), c = (e, S) => {
      const m = Number(S.toFixed(2));
      d(m), h && h(e, m);
    }, R = (e) => {
      t >= o && t < s && c(e, t + l);
    }, z = (e) => {
      t <= s && t > o && c(e, t - l);
    }, C = (e) => {
      c(e, parseFloat(e.target.value));
    };
    return p.useImperativeHandle(y, () => ({
      setValue: d,
      getValue: () => t
    })), p.useEffect(() => {
      i && d(i);
    }, [i]), /* @__PURE__ */ n.jsxs(N, { ...v, children: [
      /* @__PURE__ */ n.jsx(
        b,
        {
          variant: "no-style",
          icon: { icon: I, size: 20 },
          "aria-label": k,
          onClick: z
        }
      ),
      /* @__PURE__ */ n.jsx(
        P,
        {
          ref: j,
          id: x,
          name: "slider",
          value: t,
          min: o,
          max: s,
          step: l,
          "aria-label": w,
          onChange: (e) => C(e),
          "data-qa": "range-slider"
        }
      ),
      /* @__PURE__ */ n.jsx(
        b,
        {
          variant: "no-style",
          icon: { icon: M, size: 20 },
          "aria-label": $,
          onClick: R
        }
      )
    ] });
  }
);
T.displayName = "RangeSlider";
export {
  T as R
};
